import script from "./MiNTNewsDetailCom.vue?vue&type=script&setup=true&lang=js"
export * from "./MiNTNewsDetailCom.vue?vue&type=script&setup=true&lang=js"

import "./MiNTNewsDetailCom.vue?vue&type=style&index=0&id=e6d72ba2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6d72ba2"]])

export default __exports__